var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"p-button-rounded",attrs:{"title":"Close","id":"calculator-cancel-button","icon":"pi pi-times"},on:{"click":_vm.handleCloseClick}})}
var staticRenderFns = []

export { render, staticRenderFns }